import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import { PopupComponent } from './components/popup/popup.component';
import { CustomSpinnerComponent } from './components/custom-spinner/custom-spinner.component';

@NgModule({
    declarations: [ PopupComponent, CustomSpinnerComponent ],
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
    ],
    exports: [PopupComponent, CustomSpinnerComponent]
})
export class SharedModule { }
